import { render, staticRenderFns } from "./WidgetCollapseDrawer.vue?vue&type=template&id=dfe0ca16&"
import script from "./WidgetCollapseDrawer.vue?vue&type=script&lang=js&"
export * from "./WidgetCollapseDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WidgetCollapseDrawer.vue?vue&type=style&index=0&id=dfe0ca16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports